import React from 'react'

const Error = () => {
  return (
    <div>
      NOT FOUND
    </div>
  )
}

export default Error